import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSwitch } from "@redotech/redo-web/switch";
import { Text } from "@redotech/redo-web/text";
import { InputProvider, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const labelSettingsForm = groupInput({
  includeRedoLogo: input<boolean>(),
});

export type LabelSettingsForm = InputProvider.Form<typeof labelSettingsForm>;

export type LabelSettingsValue = InputProvider.Value<typeof labelSettingsForm>;

export const labelSettingsDefault: LabelSettingsValue = {
  includeRedoLogo: false,
};

export const LabelSettingsCard = memo(function LabelSettingsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  const { labelSettings } = input.inputs;

  return (
    <Card title="Label Settings" w="full">
      <Flex dir="column" gap="md">
        <Text fontSize="sm" textColor="warning">
          This setting is deprecated. Do not enable for new merchants.
        </Text>
        <FormSwitch
          input={labelSettings.inputs.includeRedoLogo}
          label="Include Redo logo"
        />
      </Flex>
    </Card>
  );
});
